module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-CN":{"confirm":"确认"}}')
  delete Component.options._Ctor
}
